/**
 Compares two object for equality. Considers only first level properties.
 Can be used for detecting changes in forms.
 */
export const flatObjectEqual = (obj1: any, obj2: any, undefinedEqualsEmptyString: boolean = false) => {
    if (Object.keys(obj1).length != Object.keys(obj2).length) {
        return false;
    }

    let result = true;
    for (let key in obj1) {
        let value1 = obj1[key];
        let value2 = obj2[key];

        if (undefinedEqualsEmptyString) {
            value1 = value1 ? value1 : undefined;
            value2 = value2 ? value2 : undefined;
        }
        if (value1 == value2) {
            continue;
        }
        result = false;
        break;
    }

    return result;
};